import palette from 'theme/palette'
import { colors } from '@material-ui/core'

const MuiButton = {
  label: {
    fontWeight: '500',
  },
  contained: {
    boxShadow:
      '0 1px 1px 0 rgba(0,0,0,0.14), 0 2px 1px -1px rgba(0,0,0,0.12), 0 1px 3px 0 rgba(0,0,0,0.20)',
    backgroundColor: palette.white,
  },
  containedPrimary: {
    fontWeight: '500',
    '&:hover': {
      backgroundColor: palette.primary.hover,
    },
  },
  outlined: {
    boxShadow:
      '0 1px 1px 0 rgba(0,0,0,0.14), 0 2px 1px -1px rgba(0,0,0,0.12), 0 1px 3px 0 rgba(0,0,0,0.20)',
    '&:hover': {
      backgroundColor: colors.white,
    },
  },
  root: {
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.03)',
    },
  },
}

export default MuiButton
